import { useAppContext } from '../../context/AppSettingsContextProvider'
import ScrollToTop from './ScrollToTop'
import { ErrorWrapper, Header } from '@eidsivabredband/react-component-ui-package'
import { Tab } from '@mui/material'
import { Link, Outlet, useMatch } from 'react-router-dom'
import ThemeToggle from './ThemeToggle'
import EventLogAccountMenu from './EventLogAccountMenu'
import React, { useContext } from 'react'
import { useSiteImproveTracking } from '../../hooks/siteimprove-event-tracker/UseSiteimproveEventTracker'
import { EbAuthenticatedAppContext } from '@eidsivabredband/app-framework'

interface LogMessage {
  message: string
  sourceClass?: string
  sourceMethod?: string
  sourceLineNumber?: string
}

type LogLevel = 'Info' | 'Error' | 'Warning'

enum TabValue {
  HOME = '/',
  CALENDAR = '/calendar',
  WORK = '/work',
  DASHBOARD = '/dashboard',
}
function Layout() {
  useMatch('/')
  const { isDarkTheme, setIsDarkTheme } = useAppContext()
  const { context } = useContext(EbAuthenticatedAppContext)

  const { pushEventToSiteImprove } = useSiteImproveTracking()
  const tabs = [
    <Tab value={TabValue.HOME} key={'home'} label="Hendelser" component={Link} to={TabValue.HOME} />,
    <Tab value={TabValue.CALENDAR} key={'calendar'} label="Kalender" component={Link} to={TabValue.CALENDAR} />,
    <Tab value={TabValue.WORK} key={'work'} label="Arbeid" component={Link} to={TabValue.WORK} />,
    <Tab value={TabValue.DASHBOARD} key={'dashboard'} label="Dashboard" component={Link} to={TabValue.DASHBOARD} />,
  ]
  const handleToggleTheme = () => {
    setIsDarkTheme && setIsDarkTheme(!isDarkTheme)
  }

  const handleError = (error: Error, info: React.ErrorInfo) => {
    const { stack } = error
    if (stack) {
      const logMessage: LogMessage = { message: stack }
      const logLevel: LogLevel = 'Error'
      context.restApiClient
        .buildRequest(`/api/log/${logLevel}`)
        .serializeToJsonContent(logMessage)
        .excludeAuthorizationHeader()
        .putAsync()
        .then((response: unknown) => {
          console.log(response)
        })
    }
    pushEventToSiteImprove({
      category: 'error',
      action: error.name,
      label: error.message,
    })
  }

  return (
    <>
      <ScrollToTop />
      <Header tabs={tabs} withAppDrawer={true} appLogo={'eventLog'}>
        <ThemeToggle checked={isDarkTheme} onChange={handleToggleTheme} />
        <EventLogAccountMenu />
      </Header>
      <ErrorWrapper handleError={(error, info) => handleError(error as Error, info)}>
        <Outlet />
      </ErrorWrapper>
    </>
  )
}

export default Layout
